<div #scrollContainer class="flex flex-col gap-4 overflow-y-auto p-4 h-full">
  @for (message of messages(); track message.id) {
    <bevvi-chat-message-item [message]="message" (userReply)="userReply.emit($event)" />
  }

  @if (loading()) {
    <div class="flex justify-start">
      <div class="w-full overflow-hidden rounded-[18px] rounded-bl-none bg-white p-5 shadow-sm">
        <bevvi-bot-typing-loader [dotColor]="'var(--bot-primary, #B63333)'" />
      </div>
    </div>
  }
</div>
